import { useCallback, useEffect } from 'react'
import AnimatedLoader from '../shared_components/AnimatedLoader'
import { Box } from '../shared_components/UI/Box'
import { toast } from 'react-toastify'
import { FullPageContainer, useRefetchUpdateUser } from './TwitterAuth'
import { useHistory } from 'react-router-dom'

const DiscordAuth = () => {
  const history = useHistory()
  const refetchUpdateUser = useRefetchUpdateUser()

  const verifyAndRedirect = useCallback(
    async (launchedFrom: string) => {
      try {
        const hasSuccessfullyRefetched = await refetchUpdateUser()
        if (!hasSuccessfullyRefetched) throw new Error('Failed to refetch user')
        toast.success('Discord connected successfully')
        history.replace(launchedFrom, { skipHistoryUpdate: true })
      } catch (error) {
        console.error(error)
        toast.error('Failed to connect Discord')
      }
    },
    [history, refetchUpdateUser],
  )

  useEffect(() => {
    try {
      const launchedFrom = localStorage.getItem('launched_from')
      if (!launchedFrom) throw new Error('No launched from')
      localStorage.removeItem('launched_from')
      verifyAndRedirect(launchedFrom)
    } catch (err) {
      console.error(err)
      toast.error(err.message ?? 'There was an error connecting to Discord')
      window.location.href = '/account'
    }
  }, [history, verifyAndRedirect])

  return (
    <FullPageContainer>
      <Box center>
        <AnimatedLoader onlyWhite />
      </Box>
    </FullPageContainer>
  )
}

export default DiscordAuth
